var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(
    this.$router.currentRoute.path == '/evisittool' || 
    this.$router.currentRoute.path == '/evisittoolCompany' ||
    this.$router.currentRoute.path == '/evisittoolCompanyAbout' ||
    this.$router.currentRoute.path == '/evisittoolCompanyContact'
  )?_c('NavbarEvisit'):_c('Navbar'),_c('v-main',[_c('router-view')],1),_c('VisitorTracker'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }